import React, { useState, useContext, useMemo, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledModalPrecificacao } from "../../styled-components/StyledModalPrecificacao.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import api from '../../services/api';
import Swal from "sweetalert2";
import IntlCurrencyInput from "react-intl-currency-input"
import { StldInput } from '../../styled-components/StyledInput.style';
import { StldToggleSwitch, CheckBoxWrapper, CheckBox, CheckBoxLabel } from '../../styled-components/StyledToggleSwitch.style';
import { Multiselect } from 'multiselect-react-dropdown';
import DatePicker from 'react-datepicker';
import { dateFormat } from '../../utils/dateFormatUtil';
import { DynamicRadio } from "../../components/DynamicRadio";
import { StldRadioOptions } from '../../styled-components/StyledRadioOptions.style';

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

export const ByHoraEscalonada = ({
    escalonamento,
    peritos,
    onGetPerito,
    onRemovePerito,
    removeNovoEscalonado,
    index,
    update,
    ativaBotaoExcluir

    
}) => {
    console.log("escalonamento", escalonamento);
    return (
        <li className="list-group-item" style={{ padding: "14px 4px" }}>
            <Flex.Item key={index} className="escalonado">
                <Flex className="escalonado-responsivo">
                    <Flex.Item className="full-responsivo" style={{ width: '80%' }}>
                        <StldInput>
                            <label className="focused">Descrição</label>
                            <input
                                type={'text'}
                                placeholder={"Descrição"}
                                name={"Descrição"}
                                value={escalonamento.descricao}
                                onChange={(event) => {
                                    escalonamento.descricao = event.target.value
                                    if (update !== undefined) update()
                                }}
                            />
                        </StldInput>
                    </Flex.Item>
                    <Flex.Item className="full-responsivo ml-1" style={{ width: '20%' }}>
                        <StldInput>
                            <label className="focused">Valor Hora</label>
                            <IntlCurrencyInput
                                currency="BRL"
                                config={currencyConfig}
                                defaultValue={escalonamento.valorHoraEscalonada}
                                onChange={(_event, value, _maskedValue) => {
                                    escalonamento.valorHoraEscalonada = value
                                    if (update !== undefined) update()
                                }}
                            />
                        </StldInput>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="full-responsivo mt-1" style={{ width: '90%' }}>
                        <Multiselect
                            className="searchWrapperPrecificacao"
                            placeholder={'Profissionais'}
                            showCheckbox="true"
                            options={peritos} // Options to display in the dropdown
                            selectedValues={escalonamento.usuarios} // Preselected value to persist in dropdown
                            onSelect={(currentValue, value) => onGetPerito(currentValue, value, index)} // Function will trigger on select event
                            onRemove={onRemovePerito} // Function will trigger on remove event
                            displayValue="label" // Property name to display in the dropdown options
                        />
                    </Flex.Item>
                    {
                        ativaBotaoExcluir && (
                            <Flex.Item style={{ width: '10%' }}>
                                <button type="button" className="default-button-red-invert-small-icon-block m-1" onClick={() => removeNovoEscalonado(index)}> <i className="fa fa-trash-o" aria-hidden="true"></i></button>
                            </Flex.Item>
                        )
                    }
                </Flex>
            </Flex.Item>
        </li>
    );
}

export const ModalConfigurarPreco = ({ timesheetPrecificacao, isOpen, onAfterOpen, onRequestClose, loadPage, peritos }) => {
    const { timesheet } = useContext(TimeSheetDetalhesContext);

    useEffect(() => {
        if (timesheetPrecificacao != null) {
            setisPorAtividade(timesheetPrecificacao.isPorAtividade)
            setisPorAcionamento(!timesheetPrecificacao.isPorAtividade)

            if (timesheetPrecificacao.isPorAtividade) {
                timesheetPrecificacao.horasEscalonadas = [{
                    descricao: "",
                    valorHoraEscalonada: 0,
                    usuarios: []
                }]
                timesheetPrecificacao.horasAtividades =
                    timesheetPrecificacao.horasAtividades.map(atividade => {
                        if (atividade.horasEscalonadas.length == 0) {
                            atividade.horasEscalonadas = [{
                                descricao: "",
                                valorHoraEscalonada: 0,
                                usuarios: []
                            }];
                        }
                        if (atividade.horasPrejuizos.length == 0) {
                            atividade.horasPrejuizos = [{
                                valorPrejuizo: 0,
                                valorHoraPadrao: 0,
                                isValorInferior: false,
                                habilitaHoraEscalonada: false,
                                horasEscalonadas: [{
                                    descricao: "",
                                    valorHoraEscalonada: 0,
                                    usuarios: []
                                }]
                            }];
                        }
                        return {
                            ...atividade,
                            dataAtividade: dateFormat(atividade.dataAtividade),
                            horasEscalonadas: [...atividade.horasEscalonadas.map(escalonada => {
                                var usuariosIds = escalonada.usuarios;
                                escalonada.usuarios = peritos.filter(perito => {
                                    if (usuariosIds.includes(perito.id))
                                        return perito;
                                })
                                return { ...escalonada };
                            })],
                            horasPrejuizos: [...atividade.horasPrejuizos.map(prejuizo => {
                                if (prejuizo.horasEscalonadas.length > 1) {
                                    prejuizo.horasEscalonadas.map(horasEscalonada => {
                                        var usuariosIds = horasEscalonada.usuarios;
                                        horasEscalonada.usuarios = peritos.filter(perito => {
                                            if (usuariosIds.includes(perito.id))
                                                return perito;
                                        })
                                        return horasEscalonada;
                                    });
                                }
                                else {
                                    prejuizo.horasEscalonadas = [
                                        {
                                            descricao: "",
                                            valorHoraEscalonada: 0,
                                            usuarios: []
                                        }
                                    ]
                                }

                                return prejuizo;
                            })]
                        }
                    })

                if (timesheetPrecificacao.habilitaValorHoraUnitario) {
                    setTipoDaPrecificacao(tiposDePrecificacao.filter(tipo => tipo.value == 1)[0])
                }
                else if (timesheetPrecificacao.habilitaHoraEscalonada) {
                    setTipoDaPrecificacao(tiposDePrecificacao.filter(tipo => tipo.value == 2)[0])
                }
                else if (timesheetPrecificacao.habilitaValorPrejuizo) {
                    setTipoDaPrecificacao(tiposDePrecificacao.filter(tipo => tipo.value == 3)[0])
                }

                setAtividades(timesheetPrecificacao.horasAtividades);
            }
            else {
                timesheetPrecificacao.horasAtividades = [{
                    dataAtividade: new Date(),
                    habilitaValorHoraUnitario: false,
                    valorHoraUnitario: 0,
                    valorHoraPadrao: 0,
                    habilitaValorHoraUnitario: false,
                    habilitaHoraEscalonada: false,
                    habilitaValorPrejuizo: false,
                    horasEscalonadas: [{
                        descricao: "",
                        valorHoraEscalonada: 0,
                        usuarios: []
                    }],
                }]
                if (timesheetPrecificacao.habilitaValorHoraUnitario) {
                    timesheetPrecificacao.horasEscalonadas = [{
                        descricao: "",
                        valorHoraEscalonada: 0,
                        usuarios: []
                    }];
                }
                else if (timesheetPrecificacao.habilitaHoraEscalonada) {
                    timesheetPrecificacao.horasEscalonadas.map(horasEscalonada => {
                        var usuariosIds = horasEscalonada.usuarios;
                        horasEscalonada.usuarios = peritos.filter(perito => {
                            if (usuariosIds.includes(perito.id))
                                return perito;
                        })
                        return horasEscalonada;
                    });
                }
                else if (timesheetPrecificacao.habilitaValorPrejuizo) {
                    var horasPrejuizos = timesheetPrecificacao.horasPrejuizos.map(prejuizo => {
                        if (prejuizo.horasEscalonadas.length > 1) {
                            prejuizo.horasEscalonadas.map(horasEscalonada => {
                                var usuariosIds = horasEscalonada.usuarios;
                                horasEscalonada.usuarios = peritos.filter(perito => {
                                    if (usuariosIds.includes(perito.id))
                                        return perito;
                                })
                                return horasEscalonada;
                            });
                        }
                        else {
                            prejuizo.horasEscalonadas = [
                                {
                                    descricao: "",
                                    valorHoraEscalonada: 0,
                                    usuarios: []
                                }
                            ]
                        }

                        return prejuizo;
                    });
                    setPrejuizos(horasPrejuizos)
                }
            }

            setPrecificacao(timesheetPrecificacao)
        }
    }, [timesheetPrecificacao]);

    const tiposDePrecificacao = useMemo(() => [
        {
            "value": 1,
            "id": "Valor Unitário",
            "label": "Valor Unitário"
        },
        {
            "value": 2,
            "id": "Valor Escalonado",
            "label": "Valor Escalonado"
        },
        {
            "value": 3,
            "id": "Valor de Prejuízo",
            "label": "Valor de Prejuízo"
        }
    ], []);

    const [prejuizos, setPrejuizos] = useState([{
        valorPrejuizo: 0,
        valorHoraPadrao: 0,
        isValorInferior: false,
        habilitaHoraEscalonada: false,
        horasEscalonadas: [{
            descricao: "",
            valorHoraEscalonada: 0,
            usuarios: []
        }]
    }]);

    const [atividades, setAtividades] = useState([{
        dataAtividade: new Date(),
        habilitaValorHoraUnitario: false,
        valorHoraUnitario: 0,
        valorHoraPadrao: 0,
        habilitaValorPrejuizo: false,
        habilitaHoraEscalonada: false,
        horasEscalonadas: [{
            descricao: "",
            valorHoraEscalonada: 0,
            usuarios: []
        }],
        horasPrejuizos: [{
            valorPrejuizo: 0,
            valorHoraPadrao: 0,
            isValorInferior: false,
            habilitaHoraEscalonada: false,
            horasEscalonadas: [{
                descricao: "",
                valorHoraEscalonada: 0,
                usuarios: []
            }]
        }],
    }]);

    const [tipoDaPrecificacao, setTipoDaPrecificacao] = useState(null);
    const [isPorAtividade, setisPorAtividade] = useState(false);
    const [isPorAcionamento, setisPorAcionamento] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const [precificacao, setPrecificacao] = useState({
        idTimesheet: timesheet?.timesheet?.idTimesheet,
        IsPorAtividade: null,
        valorHoraUnitario: 0,
        habilitaValorHoraUnitario: false,
        habilitaHoraEscalonada: false,
        habilitaValorPrejuizo: false,
        valorHoraPadrao: 0,
        horasEscalonadas: [{
            descricao: "",
            valorHoraEscalonada: 0,
            usuarios: []
        }],
        horasPrejuizos: [{
            valorPrejuizo: 0,
            valorHoraPadrao: 0,
            isValorInferior: false,
            habilitaHoraEscalonada: false,
            horasEscalonadas: [{
                descricao: "",
                valorHoraEscalonada: 0,
                usuarios: []
            }]
        }],
        horasAtividades: [{
            dataAtividade: new Date(),
            habilitaValorHoraUnitario: false,
            valorHoraUnitario: 0,
            valorHoraPadrao: 0,
            habilitaValorHoraUnitario: false,
            habilitaHoraEscalonada: false,
            habilitaValorPrejuizo: false,
            horasEscalonadas: [{
                descricao: "",
                valorHoraEscalonada: 0,
                usuarios: []
            }],
        }]
    });

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '50%',
            overflowY: 'auto',
            minHeight: '70%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Configuração de preço realizado com sucesso!",
            icon: "success",
            timer: 2500,
            showConfirmButton: false,
        });
    };

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };

    const formActivities = async () => {
        var payload = { ...precificacao }
        if (isPorAtividade && verificaInputsAtividades(payload.horasAtividades))
            return

        if (isPorAcionamento) {
            if (payload.valorHoraPadrao == 0) {
                registrationFailure("É preciso informar o Valor Hora Padrão");
                return
            }

            if (!Array.isArray(payload.horasEscalonadas)) {
                payload.horasEscalonadas = [];
            }

            for (const escalonamento of payload.horasEscalonadas) {
                if (!escalonamento) continue;

                if (escalonamento.valorHoraEscalonada == 0 && escalonamento.usuarios.length > 0) {
                    registrationFailure("É preciso informar o Valor Hora")
                    return
                }

                if (escalonamento.valorHoraEscalonada != 0 && escalonamento.usuarios.length == 0) {
                    registrationFailure("É preciso selecionar ao menos 1 usuário!")
                    return
                }
            }
            payload.habilitaHoraEscalonada =
                payload.horasEscalonadas.length > 0 &&
                payload.horasEscalonadas[0].valorHoraEscalonada != 0;
            payload.habilitaValorHoraUnitario = !payload.habilitaHoraEscalonada;
        }
        payload.IsPorAtividade = isPorAtividade
        payload.idTimesheet = timesheet.timesheet.idTimesheet
        payload.horasEscalonadas = [...payload.horasEscalonadas.map(escalonamento => {
            return {
                ...escalonamento,
                usuarios: escalonamento.usuarios.map(b => b.id)
            }
        })]
        payload.horasAtividades = [
            ...payload.horasAtividades.map(atividade => {
                return {
                    ...atividade,
                    horasEscalonadas: [...atividade.horasEscalonadas.map(escalonamento => {
                        return {
                            ...escalonamento,
                            usuarios: escalonamento.usuarios.map(b => b.id)
                        }
                    })],
                    dataAtividade: atividade.dataAtividade,
                    valorHoraUnitario: atividade.valorHoraUnitario,
                    valorHoraPadrao: atividade.valorHoraPadrao,
                    habilitaValorHoraUnitario: atividade.horasEscalonadas[0].valorHoraEscalonada == 0,
                    habilitaHoraEscalonada: atividade.horasEscalonadas[0].valorHoraEscalonada != 0,
                    habilitaValorPrejuizo: false,
                };
            })
        ]

        console.log("payload", payload);

        setisLoading(true)
        await api.put(`TimesheetPrecificacao`, payload)
            .then(async (response) => {
                onRequestClose(false);
                setisLoading(false)
                registrationSuccess();
                loadPage();
            })
            .catch((error) => {
                setisLoading(false)
                registrationFailure(error?.response?.data?.notification?.messageReturn)
            });
    }

    const onGetPerito = (currentValue, value, index, escalonamentos) => {
        let peritosList = [];
        currentValue.map(perito => { peritosList.push(perito) });
        escalonamentos[index].usuarios = peritosList;
        return escalonamentos
    };

    const onRemovePerito = (currentValue, value) => {
        // onGetPerito(currentValue)
    }

    const porAtividade = { name: 'porAtividade', label: 'Por Atividade', status: isPorAtividade };
    const porAcionamento = { name: 'porAcionamento', label: 'Por Acionamento', status: isPorAcionamento };

    const porPrejuizoPorHoraEscalonada = { name: 'porPrejuizoPorHoraEscalonada', label: 'Valor Inferior', status: false };
    const habilitaHoraEscalonada = { name: 'habilitaHoraEscalonada', label: 'Hora Escalonada', status: false };

    const verificaInputsEscalonado = (escalonamentos) => {
        for (const row of escalonamentos) {
            if (row.valor == 0) {
                registrationFailure("Campo Valor Hora é obrigatório!");
                return true;
            }

            if (row.usuarios.length == 0) {
                registrationFailure("Selecione ao menos 1 profissional!");
                return true;
            }

        }
    }

    const verificaInputsAtividades = (atividades) => {
        for (const row of atividades) {
            if (!row.dataAtividade || row.dataAtividade == "") {
                registrationFailure("Campo Descrição é obrigatório!");
                return true;
            }

            if (row.valorHoraPadrao == 0) {
                registrationFailure("Campo Valor Padrão é obrigatório!");
                return true;
            }

            for (const escalonamento of row.horasEscalonadas) {
                if (escalonamento.valorHoraEscalonada == 0 && escalonamento.usuarios.length > 0) {
                    registrationFailure("É preciso informar o valor hora");
                    return true;
                }

                if (escalonamento.valorHoraEscalonada != 0 && escalonamento.usuarios.length == 0) {
                    registrationFailure("É preciso selecionar ao menos 1 usuário!");
                    return true;
                }
            }
        }
    }

    const verificaInputsPrejuizo = () => {
        for (const row of prejuizos) {
            if (row.valorPrejuizo == 0) {
                registrationFailure("Campo Valor Prejuizo é obrigatório!");
                return true;
            }

            // if(row.valorHoraPadrao == 0) {
            //     registrationFailure("Campo Valor Hora Padrão é obrigatório!");
            //     return true;
            // }

            if (row.habilitaHoraEscalonada && verificaInputsEscalonado(row.horasEscalonadas)) {
                registrationFailure("Selecione ao menos 1 hora escalonada!");
                return true;
            }

        }
    }

    const verificaInputsPrejuizoAtividade = (prejuizos) => {
        for (const row of prejuizos) {
            if (row.valorPrejuizo == 0) {
                registrationFailure("Campo Valor prejuizo é obrigatório!");
                return true;
            }

            // if(row.valorHoraPadrao == 0) {
            //     registrationFailure("Campo Valor Hora padrão é obrigatório!");
            //     return true;
            // }

            if (row.habilitaHoraEscalonada && verificaInputsEscalonado(row.horasEscalonadas)) {
                registrationFailure("Selecione ao menos 1 hora escalonada!");
                return true;
            }
        }
    }

    const addNovoEscalonado = (escalonamentos) => {
        for (const escalonamento of escalonamentos) {
            if (escalonamento.valorHoraEscalonada == 0 && escalonamento.usuarios.length > 0) {
                registrationFailure("É preciso informar o valor hora");
                return escalonamentos
            }

            if (escalonamento.valorHoraEscalonada != 0 && escalonamento.usuarios.length == 0) {
                registrationFailure("É preciso selecionar ao menos 1 usuário!");
                return escalonamentos
            }

            if (escalonamento.valorHoraEscalonada == 0 && escalonamento.usuarios.length == 0) {
                registrationFailure("É preciso selecionar ao menos 1 usuário e o valor hora!");
                return escalonamentos
            }
        }

        return [...escalonamentos, {
            descricao: "",
            valorHoraEscalonada: 0,
            usuarios: []
        }]
    }

    const addNovoEscalonadoPrejuizo = (index) => {
        if (verificaInputsEscalonado(prejuizos[index].horasEscalonadas)) {
            return true;
        }

        var pre = prejuizos.map((prej, ind) => {
            if (index == ind) {
                return {
                    ...prej,
                    horasEscalonadas: [...prej.horasEscalonadas, {
                        descricao: "",
                        valorHoraEscalonada: 0,
                        usuarios: []
                    }],
                }
            }
            else {
                return { ...prej }
            }
        })
        setPrejuizos([...pre])
    }

    const addNovoEscalonadoPrejuizoAtividade = (indexAtiv, indexPrejuizo) => {
        if (verificaInputsAtividades(atividades)) {
            return true;
        }

        var ativi = atividades.map((ativ, ind) => {
            if (indexAtiv == ind) {
                return {
                    ...ativ,
                    horasPrejuizos: [
                        ...ativ.horasPrejuizos.map((prej, indexPre) => {
                            if (indexPre == indexPrejuizo) {
                                return {
                                    ...prej,
                                    horasEscalonadas: [...prej.horasEscalonadas, {
                                        descricao: "",
                                        valorHoraEscalonada: 0,
                                        usuarios: []
                                    }],
                                }
                            }
                            else
                                return { ...ativ }
                        })
                    ]
                }
            }
            else
                return { ...ativ }
        })

        setAtividades([...ativi])
    }

    const addNovoEscalonadoAtividade = (index) => {
        if (verificaInputsEscalonado(atividades[index].horasEscalonadas)) {
            return true;
        }

        var pre = atividades.map((atividade, ind) => {
            if (index == ind) {
                atividade.horasEscalonadas.push({
                    descricao: "",
                    valorHoraEscalonada: 0,
                    usuarios: []
                })
            }

            return { ...atividade }
        })
        setAtividades([...pre])
    }

    const removeNovoEscalonadoPrejuizo = (indexPrejuizo, indexEscalonado) => {
        if (prejuizos[indexPrejuizo].horasEscalonadas.length == 1) {
            registrationFailure("É preciso informar ao menos 1 escalonamento!");
            return true;
        }

        var pre = prejuizos.map((prej, ind) => {
            var filtered = prej.horasEscalonadas.filter((prej, indEscalonado) => {
                return indEscalonado != indexEscalonado
            });
            prej.horasEscalonadas = [...filtered];
            return { ...prej }
        })
        setPrejuizos([...pre])
    }

    const removeNovoEscalonadoPrejuizoAtividade = (indexAtiv, indexEscalonado, indexPrejuizo) => {
        if (atividades[indexAtiv].horasPrejuizos[indexPrejuizo].horasEscalonadas[indexEscalonado].length == 1) {
            registrationFailure("É preciso informar ao menos 1 escalonamento!");
            return true;
        }

        var pre = prejuizos.map((prej, ind) => {
            var filtered = prej.horasEscalonadas.filter((prej, indEscalonado) => {
                return indEscalonado != indexEscalonado
            });
            prej.horasEscalonadas = [...filtered];
            return { ...prej }
        })
        setAtividades([...pre])
    }

    const addNovoAtividade = () => {
        if (verificaInputsAtividades(precificacao.horasAtividades)) {
            return true;
        }
        precificacao.horasAtividades.push(
            {
                dataAtividade: new Date(),
                habilitaValorHoraUnitario: false,
                valorHoraUnitario: 0,
                valorHoraPadrao: 0,
                habilitaValorHoraUnitario: false,
                habilitaHoraEscalonada: false,
                habilitaValorPrejuizo: false,
                horasEscalonadas: [{
                    descricao: "",
                    valorHoraEscalonada: 0,
                    usuarios: []
                }],
            }
        )
        setPrecificacao({ ...precificacao })
    }

    const removeEscalonadoAtividade = (indexAtiv, indexEscalonado) => {
        if (atividades[indexAtiv].horasEscalonadas.length == 1) {
            registrationFailure("É preciso informar ao menos 1 escalonamento!");
            return true;
        }

        var pre = atividades.map((ativ, ind) => {
            if (ind == indexAtiv) {
                var filtered = ativ.horasEscalonadas.filter((at, index) => {
                    return index != indexEscalonado
                });
                ativ.horasEscalonadas = [...filtered];
            }

            return { ...ativ }
        })
        setAtividades([...pre])
    }

    const addNovoPrejuizo = () => {
        if (verificaInputsPrejuizo()) {
            return true;
        }

        setPrejuizos([...prejuizos, {
            valorPrejuizo: 0,
            valorHoraPadrao: 0,
            isValorInferior: false,
            habilitaHoraEscalonada: false,
            horasEscalonadas: [{
                descricao: "",
                valorHoraEscalonada: 0,
                usuarios: []
            }]
        }])
    }

    const addNovoPrejuizoAtividade = (index) => {
        if (verificaInputsPrejuizoAtividade(atividades[index].horasPrejuizos)) {
            return true;
        }
        var prep = atividades.map((atividade, ind) => {
            if (index == ind) {
                atividade.horasPrejuizos.push({
                    valorPrejuizo: 0,
                    valorHoraPadrao: 0,
                    isValorInferior: false,
                    habilitaHoraEscalonada: false,
                    horasEscalonadas: [{
                        descricao: "",
                        valorHoraEscalonada: 0,
                        usuarios: []
                    }]
                })
            }

            return { ...atividade }
        })

        setAtividades([...prep])
    }

    const removeNovoEscalonado = (index, escalonamentos) => {
        console.log("escalonamentos", escalonamentos);
        let dataRow = [...escalonamentos];
        dataRow.splice(index, 1);
        return dataRow
    }

    const setPrejuizoEscalonada = (index, value) => {
        prejuizos[index].habilitaHoraEscalonada = value;
        setPrejuizos([...prejuizos])
    }

    const removeNovoAtividade = (index) => {
        let dataRow = { ...precificacao };
        dataRow.horasAtividades.splice(index, 1);
        setPrecificacao({ ...dataRow })
    }

    const removePrejuizo = (index) => {
        if (prejuizos.length == 1) {
            registrationFailure("É preciso informar ao menos 1 prejuízo!");
            return true;
        }

        let dataRow = [...prejuizos];
        dataRow.splice(index, 1);
        setPrejuizos([...dataRow]);
    }

    const removePrejuizoAtividade = (index, indexAtiv) => {
        if (atividades[indexAtiv].horasPrejuizos.length == 1) {
            registrationFailure("É preciso informar ao menos 1 prejuízo!");
            return true;
        }

        var pre = atividades.map((ativ, ind) => {
            if (ind == indexAtiv) {
                var filtered = ativ.horasPrejuizos.filter((at, index) => {
                    return index != index
                });
                ativ.horasPrejuizos = [...filtered];
            }

            return { ...ativ }
        })

        setPrejuizos([...pre]);
    }

    const setAtividadeDataLimite = (index, value) => {
        atividades[index].dataAtividade = value
        setAtividades([...atividades]);
    }

    const setAtividadeValorUnitario = (index, value) => {
        atividades[index].valorHoraUnitario = value
        setAtividades([...atividades]);
    }

    const setAtividadeValorHoraPadrao = (index, value) => {
        atividades[index].valorHoraPadrao = value
        setAtividades([...atividades]);
    }

    const typeOptions = [
        { value: true, name: "tipo", label: "Por Atividade" },
        { value: false, name: "tipo", label: "Por Acionamento" }
    ];

    const setTipoConfiguracao = (tipo) => {
        if (tipo.label == "Por Atividade") {
            setisPorAtividade(true)
            setisPorAcionamento(false)
        }
        else {
            setisPorAtividade(false)
            setisPorAcionamento(true)
        }
    }
    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Precificação"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledModalPrecificacao>
                <StyledForm>
                    <p className="modal-close" onClick={onRequestClose}>X</p>
                </StyledForm>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Configurar preço</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    {isLoading ? (
                        <div className="text-center">
                            <div className="align-items-center">
                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <Flex>
                                <StldRadioOptions>
                                    {typeOptions.map((option, index) => {
                                        return (
                                            <div key={index} className="mr-4 hover" onClick={() => setTipoConfiguracao(option)}>
                                                <input
                                                    type="radio"
                                                    value={option.value}
                                                    name={option.name}
                                                    defaultValue={isPorAtividade}

                                                    checked={
                                                        (option.label == "Por Atividade" && isPorAtividade) ||
                                                        (option.label == "Por Acionamento" && isPorAcionamento)
                                                    }
                                                    className="mr-2" />
                                                {option.label}
                                            </div>
                                        )
                                    })}
                                </StldRadioOptions>
                                {/* <DynamicRadio options={typeOptions} /> */}
                                {/* <Flex.Item style={{ width: '50%', float: "left" }}>
                                    <div className="position-relative form-group">
                                        <div className="position-relative form-group">
                                            <StldToggleSwitch>
                                                <CheckBoxWrapper>
                                                    <CheckBox
                                                        id="checkbox"
                                                        type="checkbox"
                                                        defaultChecked={porAtividade.status}
                                                        checked={porAtividade.status}
                                                        name={porAtividade.name}
                                                        value={porAtividade.status}
                                                        onChange={(event) => (setisPorAtividade(event.target.checked), setisPorAcionamento(!event.target.checked))} />
                                                    <CheckBoxLabel htmlFor="checkbox" /> {porAtividade.label}
                                                </CheckBoxWrapper>
                                            </StldToggleSwitch>
                                        </div>
                                    </div>
                                </Flex.Item>
                                <Flex.Item style={{ width: '50%', float: "left" }}>
                                    <div className="position-relative form-group">
                                        <div className="position-relative form-group">
                                            <StldToggleSwitch>
                                                <CheckBoxWrapper>
                                                    <CheckBox
                                                        id="checkbox"
                                                        type="checkbox"
                                                        defaultChecked={porAcionamento.status}
                                                        checked={porAcionamento.status}
                                                        name={porAcionamento.name}
                                                        value={porAcionamento.status}
                                                        onChange={(event) => (setisPorAcionamento(event.target.checked), setisPorAtividade(!event.target.checked))} />
                                                    <CheckBoxLabel htmlFor="checkbox" /> {porAcionamento.label}
                                                </CheckBoxWrapper>
                                            </StldToggleSwitch>
                                        </div>
                                    </div>
                                </Flex.Item> */}
                            </Flex>

                            {
                                <div style={{ display: "inline" }}>
                                    {/* <Flex.Item style={{ width: '100%' }}>
                                        <div className="position-relative form-group">
                                            <Select
                                                // isClearable={true}
                                                className="basic-single"
                                                placeholder={'Tipo da precificação'}
                                                options={tiposDePrecificacao}
                                                defaultValue={tipoDaPrecificacao}
                                                onChange={(precificacao) => setTipoDaPrecificacao(precificacao)}
                                                // onBlur={(atividade) => checkAtividade(rowsData, atividade, index)}
                                            />
                                        </div>
                                    </Flex.Item> */}
                                    {
                                        isPorAcionamento && (
                                            <>
                                                <Flex.Item style={{ width: '100%' }}>
                                                    <div className="position-relative form-group ">
                                                        {
                                                            !precificacao.habilitaHoraEscalonada && (
                                                                <div className="text-right hover add-escalonamento mb-1">
                                                                    <button type="button" className="default-button-red-small" onClick={() => {
                                                                        precificacao.habilitaHoraEscalonada = true
                                                                        setPrecificacao({ ...precificacao })
                                                                    }}>Adicionar valores escalonados</button>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            precificacao.habilitaHoraEscalonada && (
                                                                <div className="text-right hover add-escalonamento mb-1">
                                                                    <button type="button" className="default-button-red-invert-small" onClick={() => {
                                                                        precificacao.habilitaHoraEscalonada = false
                                                                        precificacao.horasEscalonadas = []; 
                                                                        setPrecificacao({ ...precificacao })
                                                                    }}>Remover valores escalonados</button>
                                                                </div>
                                                            )
                                                        }

                                                        <StldInput>
                                                            <label className="focused">Valor Hora Padrão</label>
                                                            <IntlCurrencyInput
                                                                currency="BRL"
                                                                config={currencyConfig}
                                                                defaultValue={precificacao.valorHoraPadrao}
                                                                onChange={(_event, value, _maskedValue) => {
                                                                    precificacao.valorHoraPadrao = value
                                                                    setPrecificacao({ ...precificacao })
                                                                }}
                                                            />
                                                        </StldInput>
                                                    </div>
                                                </Flex.Item>
                                                {
                                                    precificacao.habilitaHoraEscalonada && (
                                                        <div className="card">
                                                            <div className="card-header" style={{ display: "flex", justifyContent: "space-between" }}>
                                                                Valores escalonados
                                                                <button type="button" className="default-button-red-small" onClick={() => {
                                                                    precificacao.horasEscalonadas = addNovoEscalonado(precificacao.horasEscalonadas)
                                                                    setPrecificacao({ ...precificacao })
                                                                }}>Adicionar novo escalonamento</button>
                                                            </div>
                                                            <ul className="list-group list-group-flush">
                                                                {
                                                                    precificacao.horasEscalonadas.map((escalonamento, index) => {
                                                                        return (
                                                                            <ByHoraEscalonada
                                                                                key={index}
                                                                                index={index}
                                                                                ativaBotaoExcluir={true}
                                                                                onRemovePerito={(currentValue, value) => escalonamento.usuarios = currentValue}
                                                                                escalonamento={escalonamento}
                                                                                peritos={peritos}
                                                                                onGetPerito={(currentValue, value, index) => {
                                                                                    precificacao.horasEscalonadas = onGetPerito(currentValue, value, index, precificacao.horasEscalonadas)
                                                                                    setPrecificacao({ ...precificacao })
                                                                                }}
                                                                                removeNovoEscalonado={(indexRemover) => {
                                                                                    const novas = precificacao.horasEscalonadas.filter((_, i) => i !== indexRemover);

                                                                                    if (novas.length === 0) {
                                                                                        precificacao.habilitaHoraEscalonada = false;
                                                                                        precificacao.horasEscalonadas = [];
                                                                                    } else {
                                                                                        precificacao.horasEscalonadas = novas;
                                                                                    }

                                                                                    setPrecificacao({ ...precificacao });
                                                                                }}
                                                                                update={() => setPrecificacao({ ...precificacao })}
                                                                            />
                                                                        );
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )
                                                }

                                            </>
                                        )
                                    }
                                </div>
                            }
                            {/*
                            {
                                isPorAcionamento && tipoDaPrecificacao?.value == 3 && (
                                    <>
                                        <div className="position-relative form-group">
                                            <p className="modal-title">Valores por prejuízo <i className="fa fa-plus hover" onClick={addNovoPrejuizo}></i></p>
                                        </div>
                                        {
                                            prejuizos.map((prejuizo, index) => {
                                                return (
                                                    <ByPrejuizo
                                                        key={index}
                                                        prejuizo={prejuizo}
                                                        setPrejuizoEscalonada={setPrejuizoEscalonada}
                                                        porPrejuizoPorHoraEscalonada={porPrejuizoPorHoraEscalonada}
                                                        habilitaHoraEscalonada={habilitaHoraEscalonada}
                                                        index={index}
                                                        onRemovePerito={(currentValue, value) => prejuizo.horasEscalonadas.usuarios = currentValue}
                                                        peritos={peritos}
                                                        onGetPerito={(currentValue, value, index) => onGetPerito(currentValue, value, index, prejuizo.horasEscalonadas)}
                                                        removeNovoEscalonadoPrejuizo={removeNovoEscalonadoPrejuizo}
                                                        addNovoEscalonadoPrejuizo={addNovoEscalonadoPrejuizo}
                                                        update={() => setPrejuizos([...prejuizos])}
                                                        removePrejuizo={removePrejuizo}
                                                    />);
                                            })
                                        }
                                    </>
                                )
                            } */}


                            {
                                isPorAtividade && (
                                    <>
                                        <div className="card">
                                            <div className="card-header" style={{ display: "flex", justifyContent: "space-between" }}>
                                                Valores por atividade
                                                <button type="button" className="default-button-red-small" onClick={() => addNovoAtividade()}>Adicionar nova atividade</button>
                                            </div>
                                            <ul className="list-group list-group-flush">
                                                {
                                                    precificacao.horasAtividades.map((atividade, index) => {
                                                        return (
                                                            <li key={'liMconfigP' + index} className="list-group-item" style={{ padding: "0px 4px 15px 4px" }}>
                                                                <div className="escalonado atividades" key={index}>
                                                                    {
                                                                        !atividade.habilitaHoraEscalonada && (
                                                                            <div className="text-right hover add-escalonamento escalonamento-atividade">
                                                                                <button type="button" className="default-button-red-small" onClick={() => {
                                                                                    precificacao.horasAtividades[index].habilitaHoraEscalonada = true
                                                                                    setPrecificacao({ ...precificacao })
                                                                                }}>Adicionar valores escalonados</button>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {
                                                                        atividade.habilitaHoraEscalonada && (
                                                                            <div className="text-right hover add-escalonamento escalonamento-atividade">
                                                                                <button type="button" className="default-button-red-invert-small" onClick={() => {
                                                                                    precificacao.horasAtividades[index].habilitaHoraEscalonada = false
                                                                                    precificacao.horasEscalonadas = []; 
                                                                                    setPrecificacao({ ...precificacao })
                                                                                }}>Remover valores escalonados</button>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    <Flex className="escalonado-responsivo mt-3">
                                                                        <Flex.Item className="full-responsivo" style={{ width: '70%' }}>
                                                                            <StldInput>
                                                                                <label className="focused" style={{ zIndex: '1' }}>A partir de</label>
                                                                                <DatePicker
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    locale="pt-BR"
                                                                                    className="input-form"
                                                                                    defaultValue={atividade.dataAtividade}
                                                                                    selected={atividade.dataAtividade}
                                                                                    onChange={(value) => {
                                                                                        precificacao.horasAtividades[index].dataAtividade = value
                                                                                        setPrecificacao({ ...precificacao })
                                                                                    }}
                                                                                />
                                                                            </StldInput>
                                                                        </Flex.Item>
                                                                        {/* <Flex.Item style={{ width: '50%' }}>
                                                                            <StldInput>
                                                                                <label className="focused">Valor Unitário</label>
                                                                                <IntlCurrencyInput
                                                                                    currency="BRL"
                                                                                    config={currencyConfig}
                                                                                    defaultValue={atividade.valorHoraUnitario}
                                                                                    onChange={(_event, value, _maskedValue) => {
                                                                                        precificacao.horasAtividades[index].valorHoraUnitario = value
                                                                                        console.log(precificacao)
                                                                                        setPrecificacao({...precificacao})
                                                                                    }}
                                                                                />
                                                                            </StldInput>
                                                                        </Flex.Item> */}
                                                                        <Flex.Item className="full-responsivo" style={{ width: '30%' }}>
                                                                            <StldInput>
                                                                                <label className="focused">Valor Hora Padrão</label>
                                                                                <IntlCurrencyInput
                                                                                    currency="BRL"
                                                                                    config={currencyConfig}
                                                                                    defaultValue={atividade.valorHoraPadrao}
                                                                                    onChange={(_event, value, _maskedValue) => {
                                                                                        precificacao.horasAtividades[index].valorHoraPadrao = value
                                                                                        setPrecificacao({ ...precificacao })
                                                                                    }}
                                                                                />
                                                                            </StldInput>
                                                                        </Flex.Item>
                                                                        {
                                                                            (
                                                                                precificacao.horasAtividades.length > 1 &&
                                                                                (<Flex.Item style={{ width: '10%' }}>
                                                                                    <div className="hover" style={{ textAlign: 'center', marginTop: '10px' }} onClick={() => removeNovoAtividade(index)}>
                                                                                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                                                                                    </div>
                                                                                </Flex.Item>)
                                                                            )
                                                                        }
                                                                    </Flex>
                                                                    {
                                                                        atividade.habilitaHoraEscalonada && (
                                                                            <div className="card" style={{ marginTop: "15px" }}>
                                                                                <div className="card-header" style={{ display: "flex", justifyContent: "space-between" }}>
                                                                                    Valores escalonados
                                                                                    <button type="button" className="default-button-red-small" onClick={() => {
                                                                                        atividade.horasEscalonadas = addNovoEscalonado(atividade.horasEscalonadas)
                                                                                        setPrecificacao({ ...precificacao })
                                                                                    }}>Adicionar novo escalonamento</button>
                                                                                </div>
                                                                                <ul className="list-group list-group-flush">
                                                                                    {
                                                                                        atividade.horasEscalonadas.map((escalonamento, index) => {
                                                                                            return (
                                                                                                <ByHoraEscalonada
                                                                                                    key={index}
                                                                                                    index={index}
                                                                                                    ativaBotaoExcluir={true}
                                                                                                    onRemovePerito={(currentValue, value) => escalonamento.usuarios = currentValue}
                                                                                                    escalonamento={escalonamento}
                                                                                                    peritos={peritos}
                                                                                                    onGetPerito={(currentValue, value, index) => {
                                                                                                        atividade.horasEscalonadas = onGetPerito(currentValue, value, index, atividade.horasEscalonadas)
                                                                                                        setPrecificacao({ ...precificacao })
                                                                                                    }}
                                                                                                    removeNovoEscalonado={(index) => {
                                                                                                        if (atividade.horasEscalonadas.length === 1) {
                                                                                                            precificacao.horasAtividades[index].habilitaHoraEscalonada = false
                                                                                                        }
                                                                                                        else {
                                                                                                            atividade.horasEscalonadas = removeNovoEscalonado(index, atividade.horasEscalonadas)
                                                                                                        }
                                                                                                        setPrecificacao({ ...precificacao })
                                                                                                    }}
                                                                                                    update={() => setPrecificacao({ ...precificacao })}
                                                                                                />
                                                                                            );
                                                                                        })
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        )
                                                                    }

                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </>
                                )
                            }
                            {/* {
                                isPorAtividade && tipoDaPrecificacao?.value == 2 && (
                                    <>
                                        <div className="position-relative form-group">
                                            <p className="modal-title">Valores por atividade <i className="fa fa-plus hover" onClick={() => addNovoAtividade()}></i></p>
                                        </div>
                                        {
                                            atividades.map((atividade, indexAtiv) => {
                                                return (
                                                    <>
                                                        <Flex key={indexAtiv}>
                                                            <Flex.Item style={{ width: '50%' }}>
                                                                <StldInput>
                                                                    <label className="focused" style={{ zIndex: '1' }}>Data limite</label>
                                                                    <DatePicker
                                                                        dateFormat="dd/MM/yyyy"
                                                                        locale="pt-BR"
                                                                        className="input-form"
                                                                        defaultValue={atividade.dataAtividade}
                                                                        selected={atividade.dataAtividade}
                                                                        onChange={(value) => setAtividadeDataLimite(indexAtiv, value)}
                                                                    />
                                                                </StldInput>
                                                            </Flex.Item>
                                                            <Flex.Item style={{ width: '50%' }}>
                                                                <StldInput>
                                                                    <label className="focused">Valor Unitário</label>
                                                                    <IntlCurrencyInput
                                                                        currency="BRL"
                                                                        config={currencyConfig}
                                                                        defaultValue={atividade.valorHoraUnitario}
                                                                        onChange={(_event, value, _maskedValue) => setAtividadeValorUnitario(indexAtiv, value)}
                                                                    />
                                                                </StldInput>
                                                            </Flex.Item>
                                                            <Flex.Item style={{ width: '30%' }}>
                                                                <StldInput>
                                                                    <label className="focused">Valor Hora Padrão</label>
                                                                    <IntlCurrencyInput
                                                                        currency="BRL"
                                                                        config={currencyConfig}
                                                                        defaultValue={atividade.valorHoraPadrao}
                                                                        onChange={(_event, value, _maskedValue) => setAtividadeValorHoraPadrao(indexAtiv, value)}
                                                                    />
                                                                </StldInput>
                                                            </Flex.Item>
                                                            <Flex.Item style={{ width: '10%' }}>
                                                                <div className="hover" style={{ textAlign: 'center', marginTop: '10px' }} onClick={() => removeNovoAtividade(indexAtiv)}>
                                                                    <i className="fa fa-trash-o" aria-hidden="true"></i>
                                                                </div>
                                                            </Flex.Item>
                                                        </Flex>
                                                        <div style={{padding: "0 20px"}}>
                                                            <>
                                                                <div className="position-relative form-group">
                                                                    <p className="modal-title">Valores escalonados <i className="fa fa-plus hover" onClick={() => addNovoEscalonadoAtividade(indexAtiv)}></i></p>
                                                                </div>
                                                                {
                                                                    atividade.horasEscalonadas.map((escalonamento, indexEscalonado) => {
                                                                        return (
                                                                            <ByHoraEscalonada
                                                                                key={indexEscalonado}
                                                                                index={indexEscalonado}
                                                                                onRemovePerito={(currentValue, value) => escalonamento.usuarios = currentValue}
                                                                                escalonamento={escalonamento}
                                                                                peritos={peritos}
                                                                                onGetPerito={(currentValue, value, index) => onGetPerito(currentValue, value, index, atividade.horasEscalonadas)}
                                                                                removeNovoEscalonado={(indexEscalonado) => removeEscalonadoAtividade(indexAtiv, indexEscalonado)}
                                                                                update={() => setAtividades([...atividades])}
                                                                            />);
                                                                    })
                                                                }
                                                            </>
                                                        </div>
                                                        <hr></hr>
                                                    </>
                                                )
                                            })
                                        }
                                    </>
                                )
                            } */}
                            {/* {
                                isPorAtividade && tipoDaPrecificacao?.value == 3 && (
                                    <>
                                        <div className="position-relative form-group">
                                            <p className="modal-title">Valores por atividade <i className="fa fa-plus hover" onClick={() => addNovoAtividade()}></i></p>
                                        </div>
                                        {
                                            atividades.map((atividade, indexAtiv) => {
                                                return (
                                                    <>
                                                        <Flex key={indexAtiv}>
                                                            <Flex.Item style={{ width: '50%' }}>
                                                                <StldInput>
                                                                    <label className="focused" style={{ zIndex: '1' }}>Data limite</label>
                                                                    <DatePicker
                                                                        dateFormat="dd/MM/yyyy"
                                                                        locale="pt-BR"
                                                                        className="input-form"
                                                                        defaultValue={atividade.dataAtividade}
                                                                        selected={atividade.dataAtividade}
                                                                        onChange={(value) => setAtividadeDataLimite(indexAtiv, value)}
                                                                    />
                                                                </StldInput>
                                                            </Flex.Item>
                                                            <Flex.Item style={{ width: '50%' }}>
                                                                <StldInput>
                                                                    <label className="focused">Valor Unitário</label>
                                                                    <IntlCurrencyInput
                                                                        currency="BRL"
                                                                        config={currencyConfig}
                                                                        defaultValue={atividade.valorHoraUnitario}
                                                                        onChange={(_event, value, _maskedValue) => setAtividadeValorUnitario(indexAtiv, value)}
                                                                    />
                                                                </StldInput>
                                                            </Flex.Item>
                                                            <Flex.Item style={{ width: '30%' }}>
                                                                <StldInput>
                                                                    <label className="focused">Valor Hora Padrão</label>
                                                                    <IntlCurrencyInput
                                                                        currency="BRL"
                                                                        config={currencyConfig}
                                                                        defaultValue={atividade.valorHoraPadrao}
                                                                        onChange={(_event, value, _maskedValue) => setAtividadeValorHoraPadrao(indexAtiv, value)}
                                                                    />
                                                                </StldInput>
                                                            </Flex.Item>
                                                            <Flex.Item style={{ width: '10%' }}>
                                                                <div className="hover" style={{ textAlign: 'center', marginTop: '10px' }} onClick={() => removeNovoAtividade(indexAtiv)}>
                                                                    <i className="fa fa-trash-o" aria-hidden="true"></i>
                                                                </div>
                                                            </Flex.Item>
                                                        </Flex>
                                                        <div style={{padding: "0 20px"}}>
                                                        <>
                                                            <div className="position-relative form-group">
                                                                <p className="modal-title">Valores por prejuízo <i className="fa fa-plus hover" onClick={() => addNovoPrejuizoAtividade(indexAtiv)}></i></p>
                                                            </div>
                                                            {
                                                                atividade.horasPrejuizos.map((prejuizo, indexPrejuizo) => {
                                                                    return (
                                                                        <ByPrejuizo
                                                                            key={indexPrejuizo}
                                                                            prejuizo={prejuizo}
                                                                            index={indexPrejuizo}
                                                                            porPrejuizoPorHoraEscalonada={porPrejuizoPorHoraEscalonada}
                                                                            habilitaHoraEscalonada={habilitaHoraEscalonada}
                                                                            setPrejuizoEscalonada={(index, value) => {
                                                                                prejuizo.habilitaHoraEscalonada = value;
                                                                                setAtividades([...atividades])
                                                                            }}
                                                                            onRemovePerito={(currentValue, value) => {
                                                                                prejuizo.horasEscalonadas.usuarios = currentValue
                                                                                setAtividades([...atividades])
                                                                            }}
                                                                            peritos={peritos}
                                                                            onGetPerito={(currentValue, value, index) => {
                                                                                let peritosList = [];
                                                                                currentValue.map(perito => { peritosList.push(perito) });
                                                                                atividades[indexAtiv].horasPrejuizos[indexPrejuizo].horasEscalonadas[index].usuarios = peritosList;
                                                                                setAtividades([...atividades])
                                                                            }}
                                                                            removeNovoEscalonadoPrejuizo={(indexPrejuizo, indexEscalonado) => removeNovoEscalonadoPrejuizoAtividade((indexAtiv, indexEscalonado, indexPrejuizo))}
                                                                            addNovoEscalonadoPrejuizo={(index) => addNovoEscalonadoPrejuizoAtividade(indexAtiv, indexPrejuizo)}
                                                                            update={() => setAtividades([...atividades])}
                                                                            removePrejuizo={(index) => removePrejuizoAtividade(index, indexAtiv)}
                                                                        />);
                                                                })
                                                            }
                                                        </>
                                                        </div>
                                                        <hr></hr>
                                                    </>
                                                )
                                            })
                                        }
                                    </>
                                )
                            } */}

                            {
                                (isPorAcionamento || isPorAtividade) && (
                                    <Flex>
                                        <Flex.Item className="modal-width">
                                            <div className="position-relative form-group modal-align-center">
                                                <input className='default-button-red' value='Salvar' type="button" onClick={formActivities} />
                                            </div>
                                        </Flex.Item>
                                    </Flex>
                                )
                            }
                        </div>
                    )}
                </StyledForm>
            </StyledModalPrecificacao>

        </Modal>
    );
};